import {
  SearchModule,
  useMediaQuery,
  mapGolazosNftToMyCollectionMoment,
  Box,
  useAnalytics,
} from '@dapperlabs/core-fe';
import React, { useMemo } from 'react';
import { Types as SessionTypes } from 'src/edge/session';
import { MY_COLLECTION_MOMENTS_EXPANDED_FILTERS } from 'src/general/constants/localStorage';
import { useTranslation } from 'src/lib/translations';
import { SEARCH_GOLAZOS_NFT } from 'src/modules/Queries/searchNft';
import {
  BROWSE_FILTER_OPTIONS as BROWSE_FILTER_OPTIONS_GOLAZO,
  parseOptions,
  MY_COLLECTION_MOMENTS_SORT_OPTIONS as BROWSE_SORT_OPTIONS_GOLAZO,
  VARIABLES_MY_COLLECTION_MOMENTS,
} from 'src/modules/searchGolazosNft';

import { MyMomentsListItem } from './MyMomentsListItem';

export interface MyMomentsListProps {
  flowAddress: string;
  preferredLanguage: SessionTypes.Context['preferredLanguage'];
}

export const MyMomentsList = ({
  preferredLanguage,
  flowAddress,
}: MyMomentsListProps) => {
  const { t } = useTranslation();
  const [isMobile] = useMediaQuery('(max-width: 767px)');
  const { track } = useAnalytics();

  //Filter options
  const filterOptions = useMemo(
    () => BROWSE_FILTER_OPTIONS_GOLAZO(t),
    // preferred language change means generate new categoryLabels
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [preferredLanguage],
  );

  //Sort options
  const browseSortOptions = useMemo(
    () => BROWSE_SORT_OPTIONS_GOLAZO(t),
    // preferred language change means generate new categoryLabels
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [preferredLanguage],
  );

  //Pagination options
  const paginationOptions = {
    itemPerPage: 48,
    queryPaginationPath: 'searchGolazosNft.pageInfo',
  };

  const searchControllerOptions = {
    browseSortOptions,
    expandedFiltersLocalStorageKey: MY_COLLECTION_MOMENTS_EXPANDED_FILTERS,
    filterOptions,
    options: {
      analyticsJsTrack: track,
      analyticsPrefix: 'laliga-collection-select',
    },
    paginationOptions,
    parseOptions,
    query: SEARCH_GOLAZOS_NFT(),
    queryDataPath: 'searchGolazosNft',
    variables: VARIABLES_MY_COLLECTION_MOMENTS(flowAddress),
  };

  const copy = {
    BuyNow: t('MarketplaceSearch.BuyNow'),
    LowestAsk: t('MarketplaceSearch.LowestAsk'),
    MomentsBurned: t('MarketplaceSearch.MomentsBurned'),
    MomentsBurned_plural: t('MarketplaceSearch.MomentsBurned_plural'),
    ViewMomentDetails: t('MarketplaceSearch.ViewMomentDetails'),
    clearFilters: t('MarketplaceSearch.CTA.ClearAll'),
    done: isMobile
      ? t('MarketplaceSearch.CTA.ApplyFilters')
      : t('MarketplaceSearch.CTA.Done'),
    fetchMore: t('MarketplaceSearch.FetchMore'),
    filters: t('MarketplaceSearch.Filters'),
    loading: t('MarketplaceSearch.Loading'),
    result: t('MarketplaceSearch.SearchResults'),
    results: t('MarketplaceSearch.SearchResults_plural'),
    resultsEmpty: t('MarketplaceSearch.NoResults'),
    sortBy: t('MarketplaceSearch.SortBy'),
  };
  return (
    <Box mb='12'>
      <SearchModule
        NFTListingEditionCard={MyMomentsListItem}
        copy={copy}
        search2NFTListingEditionCard={mapGolazosNftToMyCollectionMoment}
        searchControllerOptions={searchControllerOptions}
      />
    </Box>
  );
};
